export default __webpack_public_path__ + "static/media/icn_list_guide_banner_1.18276b4e.svg";